import { getBrowserMetadata } from '@/hooks/use-user-platform';

/**
 * Checks the functionality of the browser based on its name and version.
 *
 * The function identifies the browser using the user-agent string and validates if the browser supports
 * the required features by comparing its version against predefined thresholds.
 *
 * @return {boolean|'partial'} Returns `true` if the browser fully supports the required functionality,
 *                              `'partial'` if the browser partially supports it, and `false` if it does not.
 */
export async function checkBrowserCompatibility(): Promise<boolean> {
  const { browserName, browserVersion } = await getBrowserMetadata();

  if (!browserName || !browserVersion) return false;

  switch (browserName) {
    case 'Chrome':
    case 'Mobile Chrome':
    case 'Google Chrome':
    case 'Edge':
    case 'Mobile Edge':
    case 'Microsoft Edge':
    case 'Chromium':
      return Number.parseInt(browserVersion) >= 111;
    case 'Firefox':
    case 'Mobile Firefox':
      return Number.parseInt(browserVersion) >= 113;
    case 'Samsung Browser':
    case 'Samsung Internet':
      return Number.parseInt(browserVersion) >= 22;
    case 'Safari':
    case 'Mobile Safari':
      return Number.parseFloat(browserVersion) >= 16.4;
    default:
      return false;
  }
}
